import { all, takeLatest, fork, put, select } from 'redux-saga/effects';
import SpecialMenuApi from 'libs/api/specialMenu';
import routeCodes from 'common/constants/route-codes';
import UIHelper from 'services/UIHelper';
import * as types from './types';
import { setModalData } from '../common/actions';

function* getSpecialMenus() {
  try {
    const currentRestaurant = yield select(
      (state) => state.common.currentRestaurant,
    );
    const api = new SpecialMenuApi(currentRestaurant?.id);
    const { data } = yield api.list({
      params: {
        per: 10000,
      },
    });
    yield put({
      type: types.SPECIAL_MENU_GET_SUCCESS,
      payload: data.special_menus,
    });
  } catch (e) {
    yield put({
      type: types.SPECIAL_MENU_GET_FAILURE,
      payload: e?.response?.data,
    });
  }
}

function* getSpecialMenuById({ payload }) {
  try {
    const currentRestaurant = yield select(
      (state) => state.common.currentRestaurant,
    );
    const api = new SpecialMenuApi(currentRestaurant?.id);
    const { data } = yield api.get(payload.id);
    yield put({
      type: types.SPECIAL_MENU_GET_BY_ID_SUCCESS,
      payload: data.special_menu,
    });
  } catch (e) {
    yield put({
      type: types.SPECIAL_MENU_GET_BY_ID_FAILURE,
      payload: e?.response?.data,
    });
  }
}

function* createOrUpdate({ payload }) {
  try {
    const currentRestaurant = yield select(
      (state) => state.common.currentRestaurant,
    );
    const api = new SpecialMenuApi(currentRestaurant?.id);
    const { id, formData, history } = payload;
    id
      ? yield api.put(id, { data: formData })
      : yield api.create({
          data: formData,
          headers: { 'Content-Type': 'multipart/Form-data' },
        });
    yield put({
      type: types.SPECIAL_MENU_CREATE_OR_UPDATE_SUCCESS,
    });
    yield put({
      type: types.SPECIAL_MENU_GET_REQUEST,
    });
    UIHelper.showCreateOrUpdateSuccess();
    history?.push(routeCodes.menu);
  } catch (e) {
    yield put({
      type: types.SPECIAL_MENU_CREATE_OR_UPDATE_FAILURE,
      payload: e?.response?.data,
    });
  }
}

function* deleteRestaurant({ payload }) {
  try {
    const { id, history } = payload;
    const currentRestaurant = yield select(
      (state) => state.common.currentRestaurant,
    );
    const api = new SpecialMenuApi(currentRestaurant.id);
    yield api.destroy(id);
    yield put({
      type: types.SPECIAL_MENU_DELETE_SUCCESS,
    });
    yield put(
      setModalData({
        open: false,
        variant: 'primary',
        title: '',
        body: '',
        itemData: {},
      }),
    );
    UIHelper.showSuccessMessage();
    yield put({
      type: types.SPECIAL_MENU_GET_REQUEST,
      payload: {},
    });
    history?.push(routeCodes.menu);
  } catch (e) {
    yield put({
      type: types.SPECIAL_MENU_DELETE_FAILURE,
      payload: e?.response?.data,
    });
  }
}

function* changeSpecialMenuPosition({ payload }) {
  try {
    const currentRestaurant = yield select(
      (state) => state.common.currentRestaurant,
    );
    const api = new SpecialMenuApi(currentRestaurant?.id);
    yield put({
      type: types.SPECIAL_MENU_CHANGE_POSITION_SUCCESS,
      payload: payload,
    });
    yield api.put(payload.id, {
      data: {
        special_menus: {
          position: payload.position + 1,
        },
      },
    });
  } catch (e) {
    yield put({
      type: types.SPECIAL_MENU_CHANGE_POSITION_SUCCESS,
      payload: {
        originalPosition: payload.position,
        position: payload.originalPosition,
      },
    });
  }
}

function* watchGetSpecialMenu() {
  yield takeLatest(types.SPECIAL_MENU_GET_REQUEST, getSpecialMenus);
}

function* watchGetSpecialMenuById() {
  yield takeLatest(types.SPECIAL_MENU_GET_BY_ID_REQUEST, getSpecialMenuById);
}

function* watchSpecialMenuCreateOrUpdate() {
  yield takeLatest(types.SPECIAL_MENU_CREATE_OR_UPDATE_REQUEST, createOrUpdate);
}

function* watchDeleteSpecialMenu() {
  yield takeLatest(types.SPECIAL_MENU_DELETE_REQUEST, deleteRestaurant);
}

function* watchChangeDishPosition() {
  yield takeLatest(
    types.SPECIAL_MENU_CHANGE_POSITION_REQUEST,
    changeSpecialMenuPosition,
  );
}

export default function* specialMenuSaga() {
  yield all([
    fork(watchSpecialMenuCreateOrUpdate),
    fork(watchGetSpecialMenu),
    fork(watchDeleteSpecialMenu),
    fork(watchGetSpecialMenuById),
    fork(watchChangeDishPosition),
  ]);
}
